<template>
  <div class="localset">
    <div class="localset__icon" @click="is_show = !is_show"></div>
    <div class="localset__menu" v-show="is_show">
      <label>
        <span class="l_title">Слагаемых: </span>
        <div class="plm">
          <div class="plm__button plm__button--minus" @click="addTerms('-')"></div>
          <input type="number" min="3" max="999999" v-model="params.terms">
          <div class="plm__button plm__button--plus" @click="addTerms('+')"></div>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import { mental_params_mix } from "../mental/mental_params_mixin";
export default {
  mixins: [
    mental_params_mix
  ],
  name: "local_setting",
  data() {
    return {
      is_show: false,
    }
  },
  props: {
    params: ''
  },
  watch: {
    params: {
      handler: function (newValue) {
        this.$emit('params_changed', this.params);
      },
      deep: true
    }
  }
}
</script>